import { APEX } from "../constants/businessTerritory";
import { KeycloakProfile } from "../redux/reducers/auth";

export   const isApexUser = (user: KeycloakProfile) => {
    return user && user.businessTerritoryId === APEX;
  }